import {
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';

import championship2Logo from '../../assets/images/championship-logo@2x.png';
import OnboardingLayout from '../../layouts/onboarding-layout/onboarding-layout';
import LoginForm from './components/LoginForm';

const useStyles = makeStyles((theme: any) =>
  createStyles({
    formSlot: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: theme.spacing(0, 3, 6),
    },
  })
);

const SignInScene = ({
  t,
  theme,
  handleOAuthLogin,
  handleSendEmailLink,
  oauthError,
  loginScene,
  handleChangeScene,
  initialValues,
}: any) => {
  const SM = useMediaQuery(`(max-width:${theme.spacing(75)})`);
  const classes = useStyles();
  return (
    <OnboardingLayout>
      <Grid
        container
        item
        xs={12}
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Grid
          item
          style={{
            justifyContent: 'center',
            display: 'flex',
            marginTop: SM ? theme.spacing(5) : theme.spacing(9),
          }}
        >
          <img
            src={championship2Logo}
            alt="logo"
            style={{ width: SM ? theme.spacing(25) : theme.spacing(50) }}
          />
        </Grid>
        <Grid
          item
          style={{
            marginTop: SM ? theme.spacing(7) : theme.spacing(10),
            marginBottom: SM ? theme.spacing(7) : theme.spacing(10),
          }}
        >
          <Typography
            variant={SM ? 'h5' : 'h4'}
            style={{
              color: theme.palette.dualText.primary,
              textAlign: 'center',
              wordWrap: 'break-word',
            }}
          >
            {t('common:welcome-signin')}
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.formSlot}>
          <LoginForm
            handleOAuthLogin={handleOAuthLogin}
            handleSendEmailLink={handleSendEmailLink}
            oauthError={oauthError}
            loginScene={loginScene}
            handleChangeScene={handleChangeScene}
            initialValues={initialValues}
          />
        </Grid>
      </Grid>
    </OnboardingLayout>
  );
};

export default SignInScene;
